import React from 'react'
import { Stack } from '@mui/material'
import { ComparisonTableRowProps } from './_props'
import ComparisonTableCell from './ComparisonTableCell'
import { generateRandomGuiID } from '../../../utils/commonUtils'
import sxs from './ComparisonTableRow.sxs'

const ComparisonTableRow: React.FC<ComparisonTableRowProps> = ({ items }) => (
    <Stack width="100%" flexDirection="row" alignItems="stretch" sx={sxs.comparisonTableRow}>
        {items.map((cell, idx) => (
            <ComparisonTableCell
                key={generateRandomGuiID()}
                type={cell?.type}
                state={cell?.state}
                label={cell.label}
                helperText={cell?.helperText}
                icon={cell?.icon}
                flex={idx === 0 ? 1 : 2}
            />
        ))}
    </Stack>
)

export default ComparisonTableRow
